import * as noUiSlider from "nouislider/distribute/nouislider.min.js";
import Rx from "rxjs/Rx";
/*
    - We assume that we have only 1 search panel.
 */

/*
    public API:
    - constructor
    - getRange(): number[]
    - initialized: boolean
    - events: {
        selectionChanged$: Observable
    }
 */

export default class RentFilter {
    /**
     * @public
     */
    constructor() {
        this.initialized = false;
        this.innerSlider = null;
        this.valueSpans = null;
        this.selectionChangedSource = new Rx.Subject();
        this.events = {
            selectionChanged$: this.selectionChangedSource.asObservable(),
        };

        this.initialize();
    }

    /**
     * @private
     */
    initialize() {
        const searchPanels = document.getElementsByClassName("apartment-search-panel");

        if (!searchPanels.length) {
            this.initialized = false;
            return;
        }

        const node = searchPanels[0].getElementsByClassName("rent-filter")[0];
        this.valueSpans = node.getElementsByTagName("span");
        const { max } = node.dataset;

        this.innerSlider = noUiSlider.create(document.getElementById("rent-slider-range"), {
            start: +max,
            connect: [true, false],
            range: {
                min: 0,
                max: +max,
            },
            step: 50,
        });

        // A slider is moved by something
        this.innerSlider.on("update", values => this.renderValues(values));
        // A handle is released after dragging
        this.innerSlider.on("change", () => {
            this.selectionChangedSource.next();
            this.updateDataAttr();
        });

        this.updateDataAttr();

        this.initialized = true;
    }

    /**
     * @private
     */
    updateDataAttr() {
        const node = document.getElementById("searchPanel");
        node.dataset.rent = JSON.stringify(this.getRange());
    }

    /**
     * @public
     */
    getRange() {
        return parseInt(this.innerSlider.get(), 10) || 0;
    }

    /**
     * @private
     */
    renderValues(values) {
        // eslint-disable-next-line prefer-destructuring
        this.valueSpans[0].innerHTML = parseInt(values[0], 10);
    }
}
